const CART_TOKEN_KEY = "ohnuts_cart_token";
const CART_ITEMS_KEY = "ohnuts_cart_items";
const MULTI_ADDRESS_KEY = "ohnuts_multi_address_info";

const SINGLE_CART_TOKEN_KEY = "ohnuts_cart_token_single";
const SINGLE_CART_ITEMS_KEY = "ohnuts_cart_items_single";
const SINGLE_ADDRESS_KEY = "ohnuts_single_address_info";

const GUEST_ADDRESS_LIST = "ohnuts_guest_address_list";
const ADDRESS_REMOVAL_KEY = "address-removal-info";
const UPS_GROUND_EXCEPTION_STATES = [
  "Connecticut",
  "Delaware",
  "New Jersey",
  "New York",
  "Pennsylvania",
];
const SHIPPING_METHODS_UPS_GROUND_DELIVERY_RANGE = [];
let SHIPPING_METHODS_FREE_SHIPPING_DELIVERY_RANGE = [7,7];

const EDIT_PEN_SVG = `<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" style="pointer-events: none;">
  <mask style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="19" height="18">
    <rect x="0.5" width="18" height="18" fill="#D9D9D9"></rect>
  </mask>
  <g>
    <path d="M1.99805 18V15.4875H16.998V18H1.99805ZM4.74811 12.2376H5.64811L12.4855 5.40619L11.5793 4.5L4.74811 11.3376V12.2376ZM3.49805 13.4874V10.8249L12.4731 1.85625C12.5939 1.73537 12.7303 1.64581 12.8824 1.58756C13.0345 1.52919 13.1897 1.5 13.348 1.5C13.5064 1.5 13.6647 1.52919 13.8231 1.58756C13.9814 1.64581 14.1189 1.73744 14.2356 1.86244L15.1292 2.76244C15.2542 2.87494 15.347 3.01038 15.4075 3.16875C15.4679 3.32713 15.498 3.48544 15.498 3.64369C15.498 3.79794 15.4679 3.95106 15.4075 4.10306C15.347 4.25519 15.2542 4.39375 15.1292 4.51875L6.16055 13.4874H3.49805Z" fill="#999999"></path>
  </g>
</svg>`;
const BIN_SVG = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="pointer-events: none;">
  <path d="M20.4375 2.8125H16.9219V2.10938C16.9219 0.946266 15.9756 0 14.8125 0H9.1875C8.02439 0 7.07812 0.946266 7.07812 2.10938V2.8125H3.5625C2.39939 2.8125 1.45312 3.75877 1.45312 4.92188C1.45312 5.856 2.06367 6.64973 2.90648 6.9263L4.16062 22.0658C4.25095 23.1504 5.1743 24 6.26269 24H17.7373C18.8258 24 19.7491 23.1504 19.8395 22.0654L21.0935 6.92625C21.9363 6.64973 22.5469 5.856 22.5469 4.92188C22.5469 3.75877 21.6006 2.8125 20.4375 2.8125ZM8.48438 2.10938C8.48438 1.72167 8.7998 1.40625 9.1875 1.40625H14.8125C15.2002 1.40625 15.5156 1.72167 15.5156 2.10938V2.8125H8.48438V2.10938ZM18.438 21.949C18.4079 22.3105 18.1001 22.5938 17.7373 22.5938H6.26269C5.89992 22.5938 5.59214 22.3105 5.56209 21.9494L4.32628 7.03125H19.6737L18.438 21.949ZM20.4375 5.625H3.5625C3.1748 5.625 2.85938 5.30958 2.85938 4.92188C2.85938 4.53417 3.1748 4.21875 3.5625 4.21875H20.4375C20.8252 4.21875 21.1406 4.53417 21.1406 4.92188C21.1406 5.30958 20.8252 5.625 20.4375 5.625Z" fill="#525252"></path>
  <path d="M9.1862 20.4409L8.48307 9.09715C8.45902 8.70954 8.12354 8.41474 7.73781 8.43888C7.3502 8.46293 7.05549 8.79659 7.07949 9.18415L7.78262 20.5279C7.80573 20.9007 8.11529 21.1876 8.48373 21.1876C8.89093 21.1876 9.21118 20.8446 9.1862 20.4409Z" fill="#525252"></path>
  <path d="M12 8.4375C11.6117 8.4375 11.2969 8.75231 11.2969 9.14062V20.4844C11.2969 20.8727 11.6117 21.1875 12 21.1875C12.3883 21.1875 12.7031 20.8727 12.7031 20.4844V9.14062C12.7031 8.75231 12.3883 8.4375 12 8.4375Z" fill="#525252"></path>
  <path d="M16.2623 8.43887C15.8755 8.41483 15.541 8.70953 15.517 9.09714L14.8139 20.4409C14.7899 20.8285 15.0846 21.1621 15.4722 21.1862C15.86 21.2102 16.1934 20.9153 16.2174 20.5279L16.9206 9.18414C16.9446 8.79653 16.6499 8.46287 16.2623 8.43887Z" fill="#525252"></path>
</svg>`;
const GREEN_ADD_SVG = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="pointer-events: none;">
	<mask style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
		<rect width="24" height="24" fill="#D9D9D9"/>
	</mask>
	<g>
		<path d="M10.6711 13.325H4.51562V10.675H10.6711V4.51953H13.3211V10.675H19.4766V13.325H13.3211V19.4805H10.6711V13.325Z" fill="#3BADA3"/>
	</g>
</svg>`;
const CROSS_SVG = `<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" style="pointer-events: none;">
	<path d="M4.8 12.0117L4 11.2117L7.2 8.01172L4 4.81172L4.8 4.01172L8 7.21172L11.2 4.01172L12 4.81172L8.8 8.01172L12 11.2117L11.2 12.0117L8 8.81172L4.8 12.0117Z" fill="white"/>
</svg>`;

const CART_REDIRECT_URL = window.Shopify.routes.root + "cart";
const SINGLE_ADDRESS_SHIPPING_URL = window.Shopify.routes.root + "pages/single-address-shipping";
const SINGLE_ADDRESS_CREATE_URL = window.Shopify.routes.root + "pages/address-create";
const SINGLE_ADDRESS_UPDATE_URL = window.Shopify.routes.root + "pages/address-update";
const ADDRESS_LIST_URL = window.Shopify.routes.root + "pages/address-list";
const MULTI_SHIP_CART_URL = window.Shopify.routes.root + "pages/multi-ship-cart";
const MULTI_SHIP_ADDRESS_URL = window.Shopify.routes.root + "pages/multi-address-shipping";
//const SHOPIFY_APP_BASE_URL = "https://shopifymultishipapp-ec3e3bef6fd5.herokuapp.com";//flask;
const SHOPIFY_APP_BASE_URL = "https://multi-address-order-30436288b667.herokuapp.com/api";//remix;

const CART_ITEM_REQUIRED_PROPERTIES = [
  "variant_id",
  "product_id",
  "quantity",
  "properties",
  "title",
  "image",
  "sku",
  "url",
  "original_price",
  "original_line_price",
  "final_price",
  "final_line_price",
];

const COMPLETE_ADDRESS_REQUIRED_FIELDS = [
  "address1",
  "city",
  "province",
  "country"
];


function storageDriver() {
  return window.localStorage;
}

function saveOhnutsInfo(infoKey, infoValue) {
  const driver = storageDriver();
  driver.setItem(infoKey, infoValue);
  if (infoKey == MULTI_ADDRESS_KEY) {
    localStorage.removeItem("ohnuts_multi_draft_order_info");
  } else {
    localStorage.removeItem("ohnuts_single_draft_order_info");
  }
  hideOhnutsLoadingSpinner();
}

function getOhnutsInfo(infoKey) {
  const driver = storageDriver();
  return driver.getItem(infoKey);
}

function removeOhnutsInfo(infoKey) {
  const driver = storageDriver();
  driver.removeItem(infoKey);
}

function showOhnutsCustomModal(
  description = "",
  title = "Multi-address Shipping",
  btnTxt = "Close",
  btnLink = "",
  callback = null,
  showCloseButton = false
) {
  // Create the modal container
  const modal = document.createElement("div");
  modal.classList.add("ohnust-cas-modal");

  // Create modal content
  const modalContent = document.createElement("div");
  modalContent.classList.add("ohnust-cas-modal-content");

  // Add text content inside modal
  modalContent.innerHTML = `<h2>${title}</h2><p>${description}</p>`;

  // Create a button container
  const buttonContainer = document.createElement("div");
  buttonContainer.classList.add("ohnust-cas-modal-button-container");

  // Create a main button
  const mainButton = document.createElement("button");
  mainButton.textContent = btnTxt;
  mainButton.classList.add("ohnust-cas-modal-close-btn");

  // Add main functionality
  mainButton.onclick = function() {
    document.body.removeChild(modal);
    if (btnLink != "") {
      showOhnutsLoadingSpinner();
      window.location.href = btnLink;
    }

    if (callback) {
      callback();
    }
  };

  // Append main button to the button container
  buttonContainer.appendChild(mainButton);

  if (showCloseButton) {
    // Create a close button
    const closeButton = document.createElement("button");
    closeButton.textContent = "Close";
    closeButton.classList.add("ohnust-cas-modal-close-btn");

    // Add close functionality
    closeButton.onclick = function() {
      document.body.removeChild(modal);
    };

    // Append close button to the button container
    buttonContainer.appendChild(closeButton);
  }

  // Append the button container to modal content
  modalContent.appendChild(buttonContainer);

  // Append modal content to modal
  modal.appendChild(modalContent);

  // Append modal to body
  document.body.appendChild(modal);

  // Display the modal
  modal.style.display = "flex";
  modal.style.zIndex = 9999;
}

function showOhnutsLrgCustomModal(
  description = "",
  title = "Multi-address Shipping",
  btnTxt = "Close",
  btnLink = "",
  callback = null,
  showCloseButton = false,
  width = "600px",
  height = "auto",
  backgroundColor = "#ffffff",
  textColor = "#000000"
) {
  // Create the modal container
  const modal = document.createElement("div");
  modal.classList.add("custom-modal");

  // Apply dynamic styles
  modal.style.display = "flex";
  modal.style.position = "fixed";
  modal.style.top = "0";
  modal.style.left = "0";
  modal.style.width = "100%";
  modal.style.height = "100%";
  modal.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
  modal.style.justifyContent = "center";
  modal.style.alignItems = "center";
  modal.style.zIndex = "9999";

  // Create modal content
  const modalContent = document.createElement("div");
  modalContent.classList.add("custom-modal-content");

  // Apply dynamic styles
  modalContent.style.width = width;
  modalContent.style.height = height;
  modalContent.style.backgroundColor = backgroundColor;
  modalContent.style.color = textColor;
  modalContent.style.padding = "20px";
  modalContent.style.borderRadius = "10px";
  modalContent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.2)";
  modalContent.style.textAlign = "center";

  // Add text content inside modal
  modalContent.innerHTML = `<h2>${title}</h2><p>${description}</p>`;

  // Create a button container
  const buttonContainer = document.createElement("div");
  buttonContainer.style.marginTop = "20px";

  // Create a main button
  const mainButton = document.createElement("button");
  mainButton.textContent = btnTxt;
  mainButton.classList.add("modal-btn");

  // Apply styles to button
  mainButton.style.padding = "10px 20px";
  mainButton.style.border = "none";
  mainButton.style.cursor = "pointer";
  mainButton.style.backgroundColor = "#7C3778";
  mainButton.style.color = "#ffffff";
  mainButton.style.borderRadius = "5px";
  mainButton.style.fontSize = "16px";

  // Add main functionality
  mainButton.onclick = function() {
    document.body.removeChild(modal);
    if (btnLink !== "") {
      showOhnutsLoadingSpinner();
      window.location.href = btnLink;
    }

    if (callback) {
      callback();
    }
  };

  // Append main button to the button container
  buttonContainer.appendChild(mainButton);

  if (showCloseButton) {
    // Create a close button
    const closeButton = document.createElement("button");
    closeButton.textContent = "Close";
    closeButton.classList.add("modal-btn");

    // Apply styles
    closeButton.style.marginLeft = "10px";
    closeButton.style.padding = "10px 20px";
    closeButton.style.border = "none";
    closeButton.style.cursor = "pointer";
    closeButton.style.backgroundColor = "#dc3545";
    closeButton.style.color = "#ffffff";
    closeButton.style.borderRadius = "5px";
    closeButton.style.fontSize = "16px";

    // Add close functionality
    closeButton.onclick = function() {
      document.body.removeChild(modal);
    };

    // Append close button to the button container
    buttonContainer.appendChild(closeButton);
  }

  // Append the button container to modal content
  modalContent.appendChild(buttonContainer);

  // Append modal content to modal
  modal.appendChild(modalContent);

  // Append modal to body
  document.body.appendChild(modal);
}

function showOhnutsLoadingSpinner() {
  const spinnerDiv = document.getElementById("ohnust-cas-overlay-spinner");
  if (spinnerDiv) {
    spinnerDiv.style.zIndex = 999999;

    if (spinnerDiv.classList.contains("hidden")) {
      spinnerDiv.classList.remove("hidden");
    }
  }
}

function hideOhnutsLoadingSpinner() {
  const spinnerDiv = document.getElementById("ohnust-cas-overlay-spinner");
  if (spinnerDiv) {
    spinnerDiv.style.zIndex = 0;

    if (!spinnerDiv.classList.contains("hidden")) {
      spinnerDiv.classList.add("hidden");
    }
  }
}

function getCartMultiAddressInfo(key = null) {
  const addressKey = key || MULTI_ADDRESS_KEY;
  let cartMultiAddressList = {};
	const cartMultiAddressInfo = getOhnutsInfo(addressKey);
  if (cartMultiAddressInfo) {
    try {
      cartMultiAddressList = JSON.parse(cartMultiAddressInfo);
    } catch (error) {
      console.error(
        `[getCartMultiAddressInfo] Error parsing in JSON : ${error.message}`
      );
      cartMultiAddressList = {};
    }
  }

  return cartMultiAddressList;
}

function getCartItems() {
  let cartItemsList = [];
  const cartItems = getOhnutsInfo(CART_ITEMS_KEY);
  if (cartItems) {
    try {
      cartItemsList = JSON.parse(cartItems);
    } catch (error) {
      console.error(
        `[getCartItems] Error parsing in JSON : ${error.message}`
      );
      cartItemsList = [];
    }
  }

  return cartItemsList;
}

function addClassesToElements(elementSelector, classes) {
  const elements = document.querySelectorAll(elementSelector);

  if (elements) {
    elements.forEach((element) => {
      for (const cls of classes) {
        if (!element.classList.contains(cls)) {
          element.classList.add(cls);
        }
      }
    })
  }
}

function removeClassesFromElements(elementSelector, classes) {
  const elements = document.querySelectorAll(elementSelector);

  if (elements) {
    elements.forEach((element) => {
      for (const cls of classes) {
        if (element.classList.contains(cls)) {
          element.classList.remove(cls);
        }
      }
    })
  }
}

function checkInvoiceUrlAndRedirecttoCheckout(redirectLink) {
  let chk = function() {
    showOhnutsLoadingSpinner();
    fetch(redirectLink, {
      "referrerPolicy": "strict-origin-when-cross-origin",
      "body": null,
      "method": "GET",
      "mode": "cors",
      "credentials": "include"
    })
    .then(response => {
      if (response.redirected) {
        hideOhnutsLoadingSpinner();
        window.location.href = redirectLink;
      } else {
        setTimeout(chk, 1000);
      }
    })
    .catch((error) => {
      hideOhnutsLoadingSpinner();
      console.error(error);
      showOhnutsCustomModal(
        "Failed to confirm order, please try again!",
        "Confirmation Error"
      );
    })
  }

  return chk;
}

function getGuestAddressList() {
	let addressList = [];
  const guestAddresses = getOhnutsInfo(GUEST_ADDRESS_LIST);
  if (guestAddresses) {
    try {
      addressList = JSON.parse(guestAddresses);
    } catch (error) {
      console.error(
        `[getGuestAddressList] Error parsing in JSON : ${error.message}`
      );
      addressList = [];
    }
  }

  return addressList;
}

function getGuestAddressById(addressId) {
  return getGuestAddressList().find(address => address?.id === addressId) || null;
}

function saveGuestAddress(newAddress) {
  let addressList = getGuestAddressList();
  if (newAddress?.default) {
    addressList = addressList.map((address) => {
      address?.default && (address.default = false);
      return address;
    });
  }
  addressList.push(newAddress);
  saveOhnutsInfo(GUEST_ADDRESS_LIST, JSON.stringify(addressList));
}

function updateGuestAddress(address_id, updated_address) {
  let addressList = getGuestAddressList();
  if (updated_address?.default) {
    addressList = addressList.map((address) => {
      address?.default && (address.default = false);
      return address;
    });
  }
  addressList = addressList.map((address) => {
    if (address?.id && (address.id === address_id)) {
      address = updated_address;
    }
    return address;
  });
  saveOhnutsInfo(GUEST_ADDRESS_LIST, JSON.stringify(addressList));
}

function removeGuestAddressById(addressId) {
  let addressList = getGuestAddressList();
  addressList = addressList.filter(address => address?.id !== addressId);
  saveOhnutsInfo(GUEST_ADDRESS_LIST, JSON.stringify(addressList));
}

function loggedCustomerAddresses() {
  const addressesJson = document.querySelector("#logged_customer_addresses")?.innerHTML;

  if (!addressesJson) return [];

  try {
    return JSON.parse(addressesJson);
  } catch (error) {
    console.error(
      `[loggedCustomerAddresses] Error parsing in JSON : ${error.message}`
    );
    return [];
  }
}

function saveLoggedCustomerAddress(newAddress) {
  let addressList = loggedCustomerAddresses();
  if (newAddress?.default) {
    addressList = addressList.map((address) => {
      address?.default && (address.default = false);
      return address;
    });
  }
  addressList.push(newAddress);
  const loggedCustomerAddressContainer = document.querySelector("#logged_customer_addresses");

  if (!loggedCustomerAddressContainer) {
    console.error(
      "[saveLoggedCustomerAddress] logged customer address container not found"
    );
  } else {
    loggedCustomerAddressContainer.innerHTML = JSON.stringify(addressList);
  }
}

function getCustomerAddresses() {
  const customerAddresses = loggedCustomerAddresses();
  if (customerAddresses.length) return customerAddresses;
  return getGuestAddressList();
}

function isObject(variable) {
  return variable !== null && typeof variable === "object" && !Array.isArray(variable);
}

function isEmptyArray(arr) {
  return !Array.isArray(arr) || arr.length === 0;
}

function debounce(func, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };
}

function areObjectsEqual(obj1, obj2) {
  if (typeof obj1 !== "object"
    || typeof obj2 !== "object"
    || obj1 === null
    || obj2 === null
  ) {
    return false;
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    const val1 = obj1[key];
    const val2 = obj2[key];

    const areBothObjects = typeof val1 === "object" && typeof val2 === "object";
    if (areBothObjects && !areObjectsEqual(val1, val2)) {
      return false;
    }

    if (!areBothObjects && val1 !== val2) {
      return false;
    }
  }

  return true;
}

function filterObjectByProperties(obj, requiredProperties) {
  return Object.keys(obj)
    .filter(key => requiredProperties.includes(key))
    .reduce((filteredObj, key) => {
      filteredObj[key] = obj[key];
      return filteredObj;
    }, {});
}

function getSlimCartItems(cartItems) {
  if (!CART_ITEM_REQUIRED_PROPERTIES) return cartItems;

  if (Array.isArray(cartItems) && cartItems.length) {
    return cartItems
      .map(item => filterObjectByProperties(item, CART_ITEM_REQUIRED_PROPERTIES))
      .filter(item => Object.keys(item).length);
  }

  if (Object.keys(cartItems).length) {
    return filterObjectByProperties(cartItems, CART_ITEM_REQUIRED_PROPERTIES);
  }

  return cartItems;
}

function isAddressIncomplete(address) {
  if (!Object.keys(address).length) return true;

  if (!COMPLETE_ADDRESS_REQUIRED_FIELDS) return true;

  const filteredAddress = filterObjectByProperties(
    address,
    COMPLETE_ADDRESS_REQUIRED_FIELDS
  );
  if (!Object.keys(filteredAddress).length) return true;

  const filteredAddressValues = Object.values(filteredAddress).filter(Boolean);

  return (
    filteredAddressValues.length != COMPLETE_ADDRESS_REQUIRED_FIELDS.length
  );
}

function prepareShippingRateWiseDeliveryDays(shippingRates) {
  const deliveryDays = {};
  shippingRates.forEach((shippingRate) => {
    const shippingRateName = shippingRate?.name || "";
    if (shippingRateName) {
      deliveryDays[shippingRateName] = shippingRate?.delivery_days || [];
    }
  });
  return deliveryDays;
}

function prepareShippingRateWiseCodes(shippingRates) {
  const deliveryCodes = {};
  shippingRates.forEach((shippingRate) => {
    const shippingRateName = shippingRate?.name || "";
    if (shippingRateName) {
      deliveryCodes[shippingRateName] = shippingRate?.code || "";
    }
  });
  return deliveryCodes;
}

function prepareShippingRateWiseDeliveryMessage(
  shippingRates,
  adjustmentOffset = 0
) {
  const deliveryMessages = {};
  shippingRates.sort((a, b) => parseFloat(b.price) - parseFloat(a.price));

  shippingRates.forEach((shippingRate) => {
    const shippingRateName = shippingRate?.name || "";
    if (shippingRateName === "UPS® Ground") {
      const deliveryDays = !isEmptyArray(shippingRate?.delivery_days ?? [])
        ? shippingRate.delivery_days
        : null;
      if (deliveryDays) {
        SHIPPING_METHODS_UPS_GROUND_DELIVERY_RANGE.length = 0;
        SHIPPING_METHODS_UPS_GROUND_DELIVERY_RANGE.push(...deliveryDays);
        SHIPPING_METHODS_FREE_SHIPPING_DELIVERY_RANGE.length = 0;
        SHIPPING_METHODS_FREE_SHIPPING_DELIVERY_RANGE.push(
          ...deliveryDays.map(day => day + 2)
        );
      } else {
        SHIPPING_METHODS_UPS_GROUND_DELIVERY_RANGE.length = 0;
        SHIPPING_METHODS_FREE_SHIPPING_DELIVERY_RANGE.length = 0;
        SHIPPING_METHODS_UPS_GROUND_DELIVERY_RANGE.push(3, 5);
        SHIPPING_METHODS_FREE_SHIPPING_DELIVERY_RANGE.push(5, 7);
      }
    }

    if (shippingRateName) {
      deliveryMessages[shippingRateName] = generateMessageForDeliveryDays(
        shippingRate?.delivery_days || [],
        adjustmentOffset
      );
    }
  });

  return deliveryMessages;
}

function generateMessageForDeliveryDays(deliveryDays, adjustmentOffset = 0) {
  if (isEmptyArray(deliveryDays)) {
    deliveryDays = SHIPPING_METHODS_FREE_SHIPPING_DELIVERY_RANGE;
  }

  const minDays = Math.min(...deliveryDays);
  let maxDays = Math.max(...deliveryDays);
  const adjustedMinDays = (adjustmentOffset && ((minDays + parseInt(adjustmentOffset)) > 0))
    ? (minDays + parseInt(adjustmentOffset))
    : minDays;
  const adjustedMaxDays = (adjustmentOffset && ((maxDays + parseInt(adjustmentOffset)) > 0))
    ? (maxDays + parseInt(adjustmentOffset))
    : maxDays;

  if (minDays == maxDays) {
    if (minDays == 0) return "";

    const adjustedMin = formatDeliveryDate(adjustedMinDays);
    const adjustedMax = formatDeliveryDate((parseInt(adjustedMinDays)+ 1 ));
    if (adjustedMin == adjustedMax) {
      return `Estimated Delivery: ${formatDeliveryDate(adjustedMinDays)}`;//business days
    } else {
      return `Estimated Delivery: ${formatDeliveryDate(adjustedMinDays)} - ${formatDeliveryDate((parseInt(adjustedMinDays) + 1 ))}`;//business days
    }
  } else {
    if (minDays == 0) return `Estimated Delivery: ${formatDeliveryDate(adjustedMaxDays)} `;//business days
    return `Estimated Delivery: ${formatDeliveryDate(adjustedMinDays)} - ${formatDeliveryDate(adjustedMaxDays)} `;//business days
  }
}

function formatDeliveryDate(daysToAdd) {
  if (!daysToAdd || isNaN(daysToAdd)) return "Not specified"; // Validate input

  const targetDate = new Date();
  targetDate.setDate(targetDate.getDate() + Number(daysToAdd)); // Add input days to today's date
  if (targetDate.getDay() === 6) {
    targetDate.setDate(targetDate.getDate() + 2); // Move to Monday
  } else if (targetDate.getDay() === 0) {
    targetDate.setDate(targetDate.getDate() + 1); // Move to Monday
  }

  return targetDate.toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric"
  });
}

function prepareShippingRateWiseDeliveryInfo(
  shippingRates,
  adjustmentOffset = 0,
  blockDetails = {}
) {
  const hasExceptionState = hasUpsGroundExceptionState(blockDetails);
  const deliveryMessages = {};
  const deliveryStartDateObjects = {};

  shippingRates.sort((a, b) => parseFloat(b.price) - parseFloat(a.price));

  shippingRates.forEach((shippingRate) => {
    const shippingRateName = shippingRate?.name || "";

    if (shippingRateName === "UPS® Ground") {
      const deliveryDays = (Array.isArray(shippingRate?.delivery_days)
        && shippingRate.delivery_days.length > 0)
        ? shippingRate.delivery_days
        : null;

      if (deliveryDays) {
        SHIPPING_METHODS_UPS_GROUND_DELIVERY_RANGE.length = 0;
        SHIPPING_METHODS_UPS_GROUND_DELIVERY_RANGE.push(...deliveryDays);
        SHIPPING_METHODS_FREE_SHIPPING_DELIVERY_RANGE.length = 0;
        SHIPPING_METHODS_FREE_SHIPPING_DELIVERY_RANGE.push(
          ...deliveryDays.map(day => day + 2)
        );
      } else {
        SHIPPING_METHODS_UPS_GROUND_DELIVERY_RANGE.length = 0;
        SHIPPING_METHODS_FREE_SHIPPING_DELIVERY_RANGE.length = 0;
        const upsGroundDeliveryRange = hasExceptionState ? [1, 2] : [3, 5];
        SHIPPING_METHODS_UPS_GROUND_DELIVERY_RANGE.push(...upsGroundDeliveryRange);
        SHIPPING_METHODS_FREE_SHIPPING_DELIVERY_RANGE.push(5, 7);
      }
    }

    if (shippingRateName) {
      if (shippingRateName === "UPS® Ground"
        && hasExceptionState
        && SHIPPING_METHODS_UPS_GROUND_DELIVERY_RANGE.length !== 0
      ) {
        const { message, startDateObj } = generateDeliveryDaysInfo(
          shippingRate?.delivery_days || [],
          adjustmentOffset,
          SHIPPING_METHODS_UPS_GROUND_DELIVERY_RANGE
        );
        deliveryMessages[shippingRateName] = message;
        deliveryStartDateObjects[shippingRateName] = startDateObj;
      } else {
        const { message, startDateObj } = generateDeliveryDaysInfo(
          shippingRate?.delivery_days || [],
          adjustmentOffset
        );
        deliveryMessages[shippingRateName] = message;
        deliveryStartDateObjects[shippingRateName] = startDateObj;
      }
    }
  });

  return { deliveryMessages, deliveryStartDateObjects };
}

function hasUpsGroundExceptionState(block = {}) {
  if (emptyObjectChecking(block)) return false;

  const blockProvince = String(block?.address?.province ?? "").toLowerCase();
  const upsGroundExceptionStates = UPS_GROUND_EXCEPTION_STATES.map(
    state => String(state).toLowerCase()
  )
  return upsGroundExceptionStates.includes(blockProvince);
}

function generateDeliveryDaysInfo(
  deliveryDays,
  adjustmentOffset = 0,
  defaultDeliveryDays = SHIPPING_METHODS_FREE_SHIPPING_DELIVERY_RANGE
) {
  if (!Array.isArray(deliveryDays) || !deliveryDays.length) {
    deliveryDays = defaultDeliveryDays;
  }
  const minDays = Math.min(...deliveryDays);
  const maxDays = Math.max(...deliveryDays);
  const adjustedMinDays = (adjustmentOffset && ((minDays + parseInt(adjustmentOffset)) > 0))
    ? (minDays + parseInt(adjustmentOffset))
    : minDays;
  const adjustedMaxDays = (adjustmentOffset && ((maxDays + parseInt(adjustmentOffset)) > 0))
    ? (maxDays + parseInt(adjustmentOffset))
    : maxDays;

  if (minDays == maxDays) {
    if (minDays == 0) {
      return {
        message: "",
        startDateObj: getAdjustedDateSkippingWeekend(1),
      };
    }

    const adjustedMinDateObj = getAdjustedDateSkippingWeekend(adjustedMinDays);
    const adjustedMaxDateObj = getAdjustedDateSkippingWeekend(adjustedMinDays + 1);
    const adjustedMinDateFormat = formatDeliveryDateFormat(adjustedMinDateObj);
    const adjustedMaxDateFormat = formatDeliveryDateFormat(adjustedMaxDateObj);

    if (adjustedMinDateFormat == adjustedMaxDateFormat) {
      return {
        message: `Estimated Delivery: ${adjustedMinDateFormat}`,
        startDateObj: adjustedMinDateObj,
      };
    } else {
      return {
        message: `Estimated Delivery: ${adjustedMinDateFormat} - ${adjustedMaxDateFormat}`,
        startDateObj: adjustedMinDateObj,
      };
    }
  }

  const adjustedMaxDateObj = getAdjustedDateSkippingWeekend(adjustedMaxDays);
  const adjustedMaxDateFormat = formatDeliveryDateFormat(adjustedMaxDateObj);
  if (minDays == 0) {
    return {
      message: `Estimated Delivery: ${adjustedMaxDateFormat}`,
      startDateObj: adjustedMaxDateObj,
    };
  }

  const adjustedMinDateObj = getAdjustedDateSkippingWeekend(adjustedMinDays);
  const adjustedMinDateFormat = formatDeliveryDateFormat(adjustedMinDateObj);

  if (adjustedMinDateFormat == adjustedMaxDateFormat) {
    return {
      message: `Estimated Delivery: ${adjustedMinDateFormat}`,
      startDateObj: adjustedMinDateObj,
    };
  } else {
    return {
      message: `Estimated Delivery: ${adjustedMinDateFormat} - ${adjustedMaxDateFormat}`,
      startDateObj: adjustedMinDateObj,
    };
  }
}

function getAdjustedDateSkippingWeekend(daysToAdd) {
  if (!daysToAdd || isNaN(daysToAdd)) return null; // Validate input

  const targetDate = new Date();
  targetDate.setDate(targetDate.getDate() + Number(daysToAdd)); // Add input days to today's date
  if (targetDate.getDay() === 6) {
    targetDate.setDate(targetDate.getDate() + 2); // Move to Monday
  } else if (targetDate.getDay() === 0) {
    targetDate.setDate(targetDate.getDate() + 1); // Move to Monday
  }

  return targetDate;
}

function formatDeliveryDateFormat(deliveryDate) {
  if (!isValidDateObj(deliveryDate)) return "Not specified";

  return deliveryDate.toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
  });
}

function isValidDateObj(date) {
  return date instanceof Date && !isNaN(date);
}

function addMoney(...values) {
  const totalCents = values.reduce(
    (sum, value) => sum + Math.round(parseFloat(value) * 100),
    0
  );

  return Number(totalCents / 100).toFixed(2);
}

function areRequestItemsEqualsResponseItems(requestItems, response) {
  const responseItems = response?.items || null;
  if (!responseItems) return false;

  if (!Array.isArray(responseItems)) return false;

  return requestItems.every(requestItem => {
    const matchingItem = responseItems.find(
      responseItem =>
        Number(responseItem.variant_id) === Number(requestItem.id)
    );

    return !!matchingItem;
  });
}

function formattedDateStringForCalendar(dateObj) {
  if (!isValidDateObj(dateObj)) return "";

  return dateObj.toISOString().split("T")[0];
}

function updateFlatpickrCalendarMinDate(datePickerInstance, newMinDate) {
  if (datePickerInstance) {
    datePickerInstance.set("minDate", newMinDate);
  } else {
    console.warn("Flatpickr instance not found. Make sure the calendar is initialized.");
  }
}

function emptyCartRemoveLocalData() {
  fetch("/cart.js")
  .then(response => response.json())
  .then(cart => {
    if (cart.item_count === 0) {
      console.log("Cart is empty");
      removeOhnutsInfo(CART_TOKEN_KEY);
      removeOhnutsInfo(CART_ITEMS_KEY);
      removeOhnutsInfo(MULTI_ADDRESS_KEY);
      removeOhntsinfoVarientData();
    }
  });
}

function removeOhntsinfoVarientData() {
  localStorage.clear();
}

function emptyObjectChecking(obj) {
  return !isObject(obj) || Object.keys(obj).length === 0;
}
